module.exports = __webpack_public_path__ + "img/shelf-life.3fbca2c0.svg";